/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { ReportsFilterParams, ReportsListDto } from '../api/reports/reportsClient.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum ReportsActionType {
    OPEN_REPORTS_PAGE = 'Reports/ open page',
    EXIT_REPORTS_PAGE = 'Reports/ exit page',

    CHANGE_REPORT_FILTERS = 'Reports/ change report filters',

    FETCH_NEXT_REPORTS_PAGE_START = 'Reports/ fetch next reports page start',
    FETCH_REPORTS_PAGE_SUCCESS = 'Reports/ fetch reports page success',
    FETCH_REPORT_ERROR = 'Reports/ fetch report error',

    SHOW_REPORT_TOGGLE = 'Reports / show report toggle',
    REPORT_TYPE_TOGGLE = 'Reports/ set by day toggle',

    DOWNLOAD_REPORT_START = 'Reports/ download report start',
    DOWNLOAD_REPORT_SUCCESS = 'Reports/ download report success',
    DOWNLOAD_REPORT_ERROR = 'Reports/ download report error',
}

export const openReportsPageAction = () => createAction(ReportsActionType.OPEN_REPORTS_PAGE);

export const exitReportsPageAction = () => createAction(ReportsActionType.EXIT_REPORTS_PAGE);

export const changeReportFiltersAction = (params: ReportsFilterParams) =>
    createAction(ReportsActionType.CHANGE_REPORT_FILTERS, params);

export const fetchNextReportsPageStartAction = () => createAction(ReportsActionType.FETCH_NEXT_REPORTS_PAGE_START);

export const fetchReportPageSuccessAction = (payload: ReportsListDto) =>
    createAction(ReportsActionType.FETCH_REPORTS_PAGE_SUCCESS, payload);

export const fetchReportErrorAction = (notification: Notification) =>
    createAction(ReportsActionType.FETCH_REPORT_ERROR, { notification });

export const setShowReportToggleAction = (isToShow: boolean) =>
    createAction(ReportsActionType.SHOW_REPORT_TOGGLE, isToShow);

export const reportTypeToggleAction = (isByDay: boolean) => createAction(ReportsActionType.REPORT_TYPE_TOGGLE, isByDay);

export const downloadReportStartAction = (isByDay: boolean) =>
    createAction(ReportsActionType.DOWNLOAD_REPORT_START, isByDay);

export const downloadReportSuccessAction = () =>
    createAction(ReportsActionType.DOWNLOAD_REPORT_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadReportErrorAction = (notification: Notification) =>
    createAction(ReportsActionType.DOWNLOAD_REPORT_ERROR, { notification });

export type ReportsActions =
    | ReturnType<typeof openReportsPageAction>
    | ReturnType<typeof exitReportsPageAction>
    | ReturnType<typeof changeReportFiltersAction>
    | ReturnType<typeof fetchNextReportsPageStartAction>
    | ReturnType<typeof fetchReportPageSuccessAction>
    | ReturnType<typeof fetchReportErrorAction>
    | ReturnType<typeof setShowReportToggleAction>
    | ReturnType<typeof downloadReportStartAction>
    | ReturnType<typeof downloadReportSuccessAction>
    | ReturnType<typeof downloadReportErrorAction>
    | ReturnType<typeof reportTypeToggleAction>;
